//Soft scroll to any DOM element
function scroll_to(context, speed) {
  if (!speed) {
    speed = 400;
  }
  var offset = 0;
  if (context) {
    offset = context.offset().top;
  }
  $("body,html,document").animate(
    {
      scrollTop: offset
    },
    speed
  );
}